export function generateClientIntentId(): string {
  const cryptoApi = (globalThis as typeof globalThis & { crypto?: Crypto }).crypto;
  if (cryptoApi?.randomUUID) {
    return cryptoApi.randomUUID();
  }
  const random = Math.floor(Math.random() * 1_000_000)
    .toString(36)
    .padStart(4, '0');
  return 'intent-' + Date.now().toString(36) + '-' + random;
}
